import(/* webpackMode: "eager" */ "/app/src/app/(default)/home.module.scss");
import(/* webpackMode: "eager" */ "/app/src/components/home/banner/banner.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/home/collaboration-blurb/collaboration-blurb.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/home/intro-blurb/intro-blurb.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/home/outro-blurb/outro-blurb.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/home/quote/quote.module.scss");
import(/* webpackMode: "eager" */ "/app/src/components/home/sponsor-logos/sponsor-logos.tsx")